import Vue from "vue";

export default {
  SET_DESIGNS(state, payload) {
    state.designs = payload;
  },

  UPDATE_DESIGN_STATUS(state, payload) {
    const index = state.designs.findIndex((x) => x._id === payload._id);

    if (index !== -1) {
      state.designs[index].UX_Web_status = payload.UX_Web_status;
      state.designs[index].UX_Mobile_status = payload.UX_Mobile_status;
    }
  },
  // sprint means version
  SET_SELECTED_SPRINT(state, payload) {
    state.selectedSprint = payload;
  },
  // sub-sprint means sub-version like 1.1.0 or 2.0.2
  SET_SELECTED_SUB_SPRINT(state, payload) {
    state.selectedSubSprint = payload;
  },

  SET_NOTE(state, payload) {
    const index = state.designs.findIndex((x) => x._id === payload.task);
    if (index > -1) {
      state.designs[index].ux_notes.push(payload);
    }
  },

  SET_COMMENT(state, payload) {
    const index = state.designs.findIndex((x) => x._id === payload.task);

    if (index > -1) {
      const noteIndex = state.designs[index].ux_notes.findIndex(
        (x) => x.x === payload.x && x.y === payload.y
      );
      if (noteIndex > -1) {
        Vue.set(
          state.designs[index].ux_notes[noteIndex],
          "comments",
          payload.comments
        );
        // state.designs[index].ux_notes[noteIndex].comments.push(payload.comment);
      }
    }
  },

  TOGGLE_NOTES(state, payload) {
    const index = state.designs.findIndex((x) => x._id === payload.task);

    if (index > -1 && payload.isCurrent) {
      state.designs[index].ux_notes = state.designs[index].ux_notes.map(
        (n) => ({
          ...n,
          visible: payload.note && n._id === payload.note._id ? true : false,
        })
      );
    } else if (index > -1 && !payload.isCurrent) {
      Vue.set(
        state.designs[index].ux_history[payload.historyIndex],
        "ux_notes",
        state.designs[index].ux_history[payload.historyIndex].ux_notes.map(
          (n) => ({
            ...n,
            visible: payload.note && n._id === payload.note._id ? true : false,
          })
        )
      );
    }
  },

  UPDATE_DESIGN(state, payload) {
    const index = state.designs.findIndex((x) => x._id === payload._id);
    if (index !== -1) {
      Vue.set(state.designs, index, payload);
    }
  },

  SET_STATE(state, payload) {
    state[payload.key] = payload.value;
  },

  SET_SELECTED_STORY(state, payload) {
    state.selectedStory = payload;
  },

  SET_COMPONENTS(state, payload) {
    state.allComponents = payload;
  },

  SET_WIREFRAME(state, payload) {
    state.selectedImage = payload;
  },

  SET_SELECTED_COMPONENT(state, payload) {
    state.selectedComponent = payload;
  },
  SET_SELECTED_ROLES(state, payload) {
    state.setselectedroles = payload;
  },
  SET_STORIES_TYPE(state, payload) {
    state.setStoriesType = payload;
  },
  SET_MOBILE_TAG(state, payload) {
    state.selectedMobileTag = payload;
  },

  SET_ALL_IMAGES(state, payload) {
    state.allImages = payload;
  },

  SET_SPRINT_STORIES(state, payload) {
    state.selectedSprintStories = payload;
  },

  SET_DESIGN_PLATFORM(state, payload) {
    state.platform = payload;
  },

  RESET_DESIGN(state) {
    state.designs = [];
    state.selectedSprint = "";
    state.platform = "Web";
    state.version = null;
    state.selected = {};
  },
};
